export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#425840',
    light: '#F6F6F6',
  },
  secondary: {
    main: 'rgba(255, 255, 255, 0.01)',
    contrastText: '#FFFFFF',
    light: '#D9EDF7',
  },
  text: {
    primary: '#22211F',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#3A3D2F',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#F5F3F0',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#425840',
    tableSubhead: '#F5F3F0',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#F5F3F0',
    secondary: '#F8D859',
    light: '#F8FBFE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
  },
  surface: {
    grey: '#F6F6F6',
    pricing: '#3A3D2F',
    learnMore: '#F4F4F4',
    header: '#4d5043',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
